import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import moment from 'moment';
import { Drawer, Space, Pagination, Tooltip } from 'antd';
import { Modal } from 'react-bootstrap';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import Select from 'react-select';

import { useTheme } from "./theme-provider.js"
import { useAuthData } from "./auth-provider.js"
import { getCookie } from '../common_component/cookie.js';
import PageError from '../common_component/PageError.js';


export const RecurringExpenseList = () => {

    const [state, setstate] = useState(2);
    const { theme, dropdownStyleDark } = useTheme()

    const daterange_picker_ref = useRef();

    const [startDate, setStartDate] = useState(moment.utc().subtract(6, "days").format("YYYY-MM-DD"))
    const [timezone_change, set_timezone_change] = useState("+00:00");
    const [endDate, setEndDate] = useState(moment.utc().format("YYYY-MM-DD"));

    const [CurrencySymbol, setCurrencySymbol] = useState("");
    const [recurrence_expense_id, setrecurrence_expense_id] = useState("");

    const [navtype, setnavtype] = useState("Overview");
    const [Dealer_name, setDealer_name] = useState("");
    const [Recurring_Expense_details, setRecurring_Expense_details] = useState(null);
    const [Expense_history_details, setExpense_history_details] = useState([]);
    const [open, setOpen] = useState(false);

    const [expenseList, setExpenseList] = useState([]);
    const [expenseListApiState, setExpenseListApiState] = useState(false);
    const [additonalDetailsFlag, setAdditonalDetailsFlag] = useState(false);

    const [listCount, setListCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchValue, setSearchValue] = useState("");

    const [status, setstatus] = useState("");

    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);
    const [statusType, setStatusType] = useState("All");
    const apiController = useRef(new AbortController())

    // const statusTypeArray = ["EXPENSE_DRAFT", "EXPENSE_PENDING_APPROVAL", "EXPENSE_CANCELLED", "EXPENSE_REJECTED", "EXPENSE_APPROVED", "EXPENSE_PAID"]

    const [profileName, setprofileName] = useState("")
    const [scheduleStartDate, setScheduleStartDate] = useState(moment().utc().format("YYYY-MM-DD"))
    const [scheduleEndDate, setScheduleEndDate] = useState(moment().utc().add(7, "days").format("YYYY-MM-DD"))
    const [frequencyDetails, setFrequencyDetails] = useState({ frequency: 1, time_period: "week", week_day: [], month_date: 1, month: 1 })
    const [allDayCheck, setAllDayCheck] = useState(true)
    const [startTime, setStartTime] = useState(new Date().getHours() + ":" + new Date().getMinutes())
    const [endTime, setEndTime] = useState((new Date().getHours() + 5) >= 23 ? "23:59" : (new Date().getHours() + 5) + ":" + new Date().getMinutes())

    const [EditRecurringModalShow, setEditRecurringModalShow] = useState(false);
    const [StatusModalShow, setStatusModalShow] = useState(false);

    const [flowModalShow, setFlowModalShow] = useState(false)

    var page_name = "recurring-expense-list";

    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    const onRowClick = (temp_obj) => {
        let tempData = temp_obj;
        setOpen(true);
        setnavtype("Overview");
        setRecurring_Expense_details(tempData);
        getRecurringExpenseDetails(temp_obj.unique_id)
    }

    const presets = [
        { label: 'Today', start: new Date(), end: new Date() },
        { label: 'Last 7 days', start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date() },
        { label: 'Last 30 days', start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date() },
        { label: 'Last 90 days', start: new Date(new Date().setDate(new Date().getDate() - 90)), end: new Date() }
    ];

    const onClose = () => {
        setOpen(false);
        setExpense_history_details([]);
        setCurrencySymbol("");
        setRecurring_Expense_details(null);
    };

    async function getRecurringExpenseDetails(val) {
        setAdditonalDetailsFlag(true);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/recurrence-expense-summary`, { method: 'POST', body: JSON.stringify({ "email": user.email, "id": val, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        // console.log(body)

        if (body.operation == "success") {
            setExpense_history_details(body.data.expense_history_details);
            setAdditonalDetailsFlag(false);
        }
        else {
            throw "Expense details api error"
        }
    }
    async function getRecurringExpenseList(start, end, page_number, Size, search_val, st) {
        if (expenseListApiState) {
            apiController.current.abort()
            apiController.current = new AbortController()
        }
        setListCount(0);
        setExpenseListApiState(true);
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/recurrence-expense-list`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "search_value": search_val, "status_type": st, "currentPage": page_number, "rows_per_page": Size, "start_date": start, "end_date": end, "organization_id": organization_id, "page_name": page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        if (body.operation == "success") {
            var temp_data = [];
            body.data.list.map((obj) => {
                var temp_obj = {};
                temp_obj.recurrence_expense_id = obj.unique_id;
                temp_obj.Recurring_expense_name = obj.profile_name;
                temp_obj.Start_date = moment(obj.start_date).format('ll');
                temp_obj.End_date = moment(obj.end_date).format('ll');
                temp_obj.frequency = obj.frequency_details.frequency + " " + obj.frequency_details.time_period;
                temp_obj.add_date_time = moment(obj.add_date_time).format('lll');
                temp_obj.status = <span className={`badge ${((obj.add_status === "Expired") || (obj.add_status === "Cancelled")) ? "badge-danger" : "badge-primary"}`}>{obj.add_status}</span>
                temp_obj.id = obj.unique_id;

                temp_obj.actions =
                    <div className="dropdown">
                        <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                            <i className="fas fa-bars px-0"></i>
                        </button>
                        {
                            write &&
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                {
                                    obj.add_status !== "Cancelled" &&
                                    <li><a onClick={(e) => { editRecurring(obj); }} className={`dropdown-item cursor-pointer`} >Edit Details</a></li>
                                }
                                <li><a onClick={(e) => { onRowClick(obj) }} className={`dropdown-item cursor-pointer`} >View Details</a></li>
                                {
                                    obj.add_status == "Active" &&
                                    <li><a onClick={(e) => { updateStatus(obj); setStatusModalShow(true); }} className={`dropdown-item cursor-pointer`} >Cancel</a></li>
                                }
                            </ul>
                        }
                    </div>

                temp_data.push(temp_obj);
            })
            setListCount(body.data.count);
            setExpenseListApiState(false);
            setExpenseList(temp_data);
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {

            let p1 = getRecurringExpenseList(startDate, endDate, currentPage, rowsPerPage, searchValue, statusType);

            Promise.all([p1])
                .then(() => {
                    setstate(1);
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    console.log(err)
                })
        }

    }, [user, visibility, read, write])

    useEffect(() => {
        if (state == 1) {
            getRecurringExpenseList(startDate, endDate, currentPage, rowsPerPage, searchValue, statusType)
        }
    }, [startDate, endDate, currentPage, rowsPerPage, searchValue, statusType])

    const editRecurring = (obj) => {
        setrecurrence_expense_id(obj.unique_id);
        setprofileName(obj.profile_name);
        setScheduleStartDate(moment(obj.start_date).format("YYYY-MM-DD"));
        setScheduleEndDate(moment(obj.end_date).format("YYYY-MM-DD"));
        setFrequencyDetails(obj.frequency_details);
        setAllDayCheck(obj.any_time_check);
        setStartTime(obj.time);
        setEditRecurringModalShow(true);
    }

    const updateStatus = (obj) => {
        setrecurrence_expense_id(obj.unique_id);
        setstatus(obj.add_status);
        setStatusModalShow(true);
    }

    const updateRecurringExpensedetails = (e) => {
        e.preventDefault();
        if (profileName.trim() == "") {
            swal("Oops!", "Recurring Expense Name cannot be empty", "error");
            return
        }
        if (scheduleStartDate == "") {
            swal("Oops!", "Select a Start Date", "error");
            return
        }
        if (scheduleEndDate == "") {
            swal("Oops!", "Select an End Date", "error");
            return
        }
        if (frequencyDetails.frequency < 1) {
            swal("Oops!", "Frequency cannot be less than 1", "error");
            return
        }

        if (!allDayCheck) {
            if (startTime == "") {
                swal("Oops!", "Select a Start Time", "error");
                return
            }
            if (endTime == "") {
                swal("Oops!", "Select an End Time", "error");
                return
            }
        }

        var object = {};
        object.id = recurrence_expense_id
        object.profile_name = profileName
        object.start_date = scheduleStartDate
        object.end_date = scheduleEndDate

        let t = { ...frequencyDetails }
        if (frequencyDetails.time_period == "day") {
            delete t.week_day
            delete t.month_date
            delete t.month
        }
        else if (frequencyDetails.time_period == "week") {
            delete t.month_date
            delete t.month
        }
        else if (frequencyDetails.time_period == "month") {
            delete t.week_day
            delete t.month
        }
        else if (frequencyDetails.time_period == "year") {
            delete t.week_day
        }
        object.frequency_details = t

        object.all_day_check = allDayCheck
        object.start_time = allDayCheck ? null : startTime
        //object.end_time = allDayCheck?null:endTime

        object.organization_id = organization_id;
        object.page_name = page_name;

        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/update-recurrence-expense`, object, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", "Recurring Expense details updated successfully!", "success").then(() => { window.location.reload() })
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const submitStatus = (e) => {
        e.preventDefault();

        var values = { "id": recurrence_expense_id, "save_flag": true, "page_name": page_name, "organization_id": organization_id };
        setMainSubmitButtonState(true)
        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/cancel-recurrence-expense`, values, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data && res.data.operation == "success") {
                swal("Great!", "Recurrence expense cancelled successfully!", "success").then((value) => {
                    window.location.reload();
                });
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        });
    }

    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Recurring Expense List</h1>
                    <Tooltip title="SpotERP Docs" >
                        <a
                            href={`${process.env.REACT_APP_SPOTERP_DOCS}/expenses#recurring-expense-list`}
                            className='btn btn-light-primary py-2 px-3'
                            target="_blank"
                        >
                            <i className="bi bi-journal-text fs-1 px-0"></i>
                        </a>
                    </Tooltip>
                </div>
                <div>
                    {
                        state == 1 ?
                            <>
                                <div className="row gx-0 gap-5 m-2">
                                    <div className='col-md-3'>
                                        <div className="d-flex align-items-center gap-5 mx-5 my-2">
                                            <DateRangePickerComponent
                                                ref={daterange_picker_ref}
                                                allowEdit={false}
                                                focus={(e) => { daterange_picker_ref.current.show() }}
                                                delayUpdate={true}
                                                presets={presets}
                                                change={(e) => {
                                                    setStartDate(e.startDate);
                                                    setEndDate(e.endDate);
                                                }}
                                                startDate={startDate}
                                                endDate={endDate}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="card mb-5 mb-xl-8">
                                    <div className="card-body py-3">
                                        <div className='mb-5'>
                                            <input type="text" className='form-control fw-bold border border-primary' value={searchValue || ""} onChange={(e) => { setCurrentPage(1); setSearchValue(e.target.value) }} placeholder='Search...' />
                                        </div>

                                        <div className="d-flex flex-column align-items-center" style={{ minHeight: "50vh" }}>
                                            {
                                                expenseListApiState ?
                                                    <div className="spinner-border text-primary w-75px h-75px my-auto"></div>
                                                    :
                                                    expenseList.length > 0 ?
                                                        <>
                                                            <div className="mb-5 d-flex justify-content-center">
                                                                <Pagination
                                                                    total={listCount}
                                                                    onChange={(page, pageSize) => {
                                                                        setCurrentPage(page);
                                                                        if (pageSize !== rowsPerPage) {
                                                                            setCurrentPage(1);
                                                                        }
                                                                        setRowsPerPage(pageSize);
                                                                    }}
                                                                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                    showQuickJumper={true}
                                                                    pageSize={rowsPerPage}
                                                                    current={currentPage}
                                                                    showSizeChanger={true}
                                                                />
                                                            </div>

                                                            <div className='overflow-auto w-100 flex-grow-1'>
                                                                <table className="table table-row-bordered text-nowrap table-row-gray-100 align-middle gs-0 gy-3 h-preserve-whitespace" style={{ minWidth: "1000px" }} >
                                                                    <thead>
                                                                        <tr className="fw-bold text-muted">
                                                                            <th className="min-w-150px">Recurring expense name</th>
                                                                            <th className="min-w-150px">Start date</th>
                                                                            <th className="min-w-150px">End date</th>
                                                                            <th className="min-w-150px">frequency</th>
                                                                            <th className="min-w-150px">Timestamp</th>
                                                                            <th className="min-w-150px">Status</th>
                                                                            <th className="min-w-50px sticky-column" style={{ backdropFilter: 'blur(10px)' }}>Actions</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            expenseList.map((obj, indx) => {
                                                                                return (
                                                                                    <tr key={indx}>
                                                                                        <td><a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj.Recurring_expense_name}</a></td>
                                                                                        <td><a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj.Start_date}</a></td>
                                                                                        <td><a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj.End_date}</a></td>
                                                                                        <td><span className="badge badge-secondary">{obj.frequency}</span></td>
                                                                                        <td><a className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj.add_date_time}</a></td>
                                                                                        <td>{obj.status}</td>
                                                                                        <td className="sticky-column">{obj.actions}</td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                            <div className="mt-5 d-flex justify-content-center">
                                                                <Pagination
                                                                    total={listCount}
                                                                    onChange={(page, pageSize) => {
                                                                        setCurrentPage(page);
                                                                        if (pageSize !== rowsPerPage) {
                                                                            setCurrentPage(1);
                                                                        }
                                                                        setRowsPerPage(pageSize);
                                                                    }}
                                                                    showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                    pageSize={rowsPerPage}
                                                                    current={currentPage}
                                                                    showSizeChanger={true}
                                                                    showQuickJumper={true}
                                                                />
                                                            </div>
                                                        </>
                                                        :
                                                        <div className="text-muted fs-2 my-auto text-center">No data to be shown {/* <br /> <br />
                                                            <button className='btn fs-3 btn-light-primary' onClick={() => { setFlowModalShow(true) }}>
                                                                Need Help <i className="bi bi-question-circle fs-1"></i>
                                                            </button> */}
                                                        </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            state == 2 ?
                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                :
                                <PageError />
                    }
                </div>
            </div>

            <Modal show={StatusModalShow} onHide={() => { setStatusModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Cancel recurrence</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setStatusModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row">
                        <div className="col-lg-12">
                            Current Status is : {status === "PENDING_APPROVAL" ?
                                <span className="badge badge-light-warning">Pending</span>
                                :
                                status === "DRAFT" ?
                                    <span className="badge badge-secondary">Draft</span>
                                    :
                                    <span className="badge badge-success">{status}</span>
                            }<br />
                            <h3>Are you sure about cancelling recurrence details?</h3>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setStatusModalShow(false) }} className="btn btn-secondary">Close</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { submitStatus(e) }} className="btn btn-danger" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Cancel</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>

            <Modal show={EditRecurringModalShow} onHide={() => { setEditRecurringModalShow() }} size="lg" centered>
                <Modal.Header>
                    <Modal.Title>Update Recurring Expense</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setEditRecurringModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row">
                        <div className="row mb-5 align-items-center">
                            <div className="col-12">
                                <label className="required fs-5 fw-bold mb-2">Recurring Expense Name</label>
                                <input type="text" className="form-control form-control-solid" value={profileName} onChange={(e) => { setprofileName(e.target.value) }} placeholder="Recurring Expense Name" />
                                {/* <span className="form-text text-muted">Please enter Recurring Expense Name.</span> */}
                            </div>
                        </div>
                        <div className="row mb-5 align-items-center">
                            <div className='col-4'>
                                <label className="fs-5 fw-bold">Start Date</label>
                            </div>
                            <div className="col-8">
                                <input type="date" className='form-control form-control-solid' value={scheduleStartDate} onChange={(e) => { setScheduleStartDate(e.target.value) }} />
                            </div>
                        </div>
                        <div className="row mb-5 align-items-center">
                            <div className='col-4'>
                                <label className="fs-5 fw-bold">Repeat Every</label>
                            </div>
                            <div className="col-3">
                                <input type="number" className='form-control form-control-solid' value={frequencyDetails.frequency} onChange={(e) => { setFrequencyDetails({ ...frequencyDetails, frequency: parseInt(e.target.value) }) }} />
                            </div>
                            <div className="col-5">
                                <Select
                                    options={["day", "week", "month", "year"].map(x => { return { label: x.charAt(0).toUpperCase() + x.slice(1), value: x } })}
                                    onChange={(val) => { setFrequencyDetails({ ...frequencyDetails, time_period: val.value }) }}
                                    value={{ label: frequencyDetails.time_period.charAt(0).toUpperCase() + frequencyDetails.time_period.slice(1), value: frequencyDetails.time_period }}
                                    styles={theme == 'dark' ? dropdownStyleDark : {}}
                                />
                            </div>
                        </div>
                        <div className="row mb-5 align-items-center">
                            <div className='col-4'>
                                <label className="fs-5 fw-bold">End Date</label>
                            </div>
                            <div className="col-8">
                                <input type="date" className='form-control form-control-solid' value={scheduleEndDate} onChange={(e) => { setScheduleEndDate(e.target.value) }} />
                            </div>
                        </div>

                        <div className="row mb-5 align-items-center">
                            <div className="col-6 col-md-4">
                                <label className="required fs-5 fw-bold">Any Time</label>
                            </div>
                            <div className='col-6 col-md-2'>
                                <div className="form-switch">
                                    <input className="form-check-input w-45px h-30px" type="checkbox" checked={allDayCheck} onChange={(e) => { setAllDayCheck(e.target.checked) }} />
                                </div>
                            </div>
                            {
                                !allDayCheck &&
                                <>
                                    <div className='col-3'>
                                        <input type="time" className='form-control form-control-solid' value={startTime} onChange={(e) => { setStartTime(e.target.value) }} disabled={allDayCheck} />
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setEditRecurringModalShow(false) }} className="btn btn-secondary">Cancel</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { updateRecurringExpensedetails(e) }} className="btn btn-primary" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Update</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>

            <Modal show={flowModalShow} onHide={() => { setFlowModalShow(false) }} dialogClassName="h-modal-80">
                <Modal.Header>
                    <Modal.Title>
                        <span className='text-gray-500'>Order Flow Cycle</span>
                    </Modal.Title>

                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setFlowModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='container'>
                        <img src={'./images/flow_images/customer-order.png'} className='w-100' alt="Not yet provided" />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger rounded" onClick={() => { setFlowModalShow(false) }}>Cancel</button>
                </Modal.Footer>
            </Modal>

            <Drawer title={Dealer_name} width={window.innerWidth > 1200 ? 800 : 'auto'} styles={{ body: { padding: "1.5rem" } }} onClose={onClose} open={open}
                closeIcon={
                    <a onClick={onClose}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="38px" height="38px"><path fill="#f44336" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z" /><path fill="#fff" d="M29.656,15.516l2.828,2.828l-14.14,14.14l-2.828-2.828L29.656,15.516z" /><path fill="#fff" d="M32.484,29.656l-2.828,2.828l-14.14-14.14l2.828-2.828L32.484,29.656z" /></svg>
                    </a>
                }
                extra={
                    <Space>
                        {
                            (Recurring_Expense_details && write && Recurring_Expense_details.add_status !== "Cancelled") &&
                            <div className="dropdown">
                                <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i className="fas fa-bars px-0"></i>
                                </button>

                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    <li><a onClick={(e) => { editRecurring(Recurring_Expense_details); }} className={`dropdown-item cursor-pointer`} >Edit Details</a></li>
                                    {Recurring_Expense_details.add_status == "Active" &&
                                        <li><a onClick={(e) => { updateStatus(Recurring_Expense_details); }} className={`dropdown-item cursor-pointer`}  >Cancel</a></li>
                                    }
                                </ul>

                            </div>}
                    </Space>
                }

            >
                <div className="card">
                    <div className="d-flex w-100 overflow-auto">
                        <ul className="nav nav-stretch nav-line-tabs fw-bold fs-6 p-0 p-lg-10 flex-nowrap flex-grow-1">
                            <li className="nav-item mx-lg-1">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "Overview" && "active"}`} onClick={(e) => { setnavtype("Overview"); }}>Overview</a>
                            </li>
                            <li className="nav-item mx-lg-1" role="presentation">
                                <a className={`nav-link py-3 py-lg-6 text-active-primary ${navtype === "History" && "active"}`} onClick={(e) => { setnavtype("History"); }}>History</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="card">
                    {(navtype === "Overview" && Recurring_Expense_details !== null) ?
                        <>
                            <div
                                className="card border-primary mb-3 mt-2"
                                style={{ border: "2px solid #007bff", borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }}
                            >
                                <div className="card-header cursor-pointer py-3">
                                    <div className="card-title m-0">
                                        <h3 className="fw-bold m-0">
                                            {Recurring_Expense_details.profile_name}
                                        </h3>
                                    </div>
                                </div>
                                <div className="card-body p-3">
                                    <div style={{ border: "1px solid #dee2e6", borderRadius: "0.5rem", padding: "10px", marginBottom: "20px" }}>
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">Start Date</label>
                                            <div className="col-lg-8 fv-row">
                                                <span className="fw-semibold text-gray-800 fs-6">{moment(Recurring_Expense_details.start_date).format("ll")}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">End Date</label>
                                            <div className="col-lg-8 fv-row">
                                                <span className="fw-semibold text-gray-800 fs-6">{moment(Recurring_Expense_details.end_date).format("ll")}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">Frequency</label>
                                            <div className="col-lg-8 fv-row">
                                                <span className="fw-semibold text-gray-800 fs-6">{Recurring_Expense_details.frequency_details.frequency + " " + Recurring_Expense_details.frequency_details.time_period}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">Time</label>
                                            <div className="col-lg-8 fv-row">
                                                <span className="badge badge-light-primary">{Recurring_Expense_details.time}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">Add date</label>
                                            <div className="col-lg-8 fv-row">
                                                <span className="fw-semibold text-gray-800 fs-6">{moment(Recurring_Expense_details.add_date_time).format("ll")}</span>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-lg-4 fw-semibold text-muted">Status
                                            </label>
                                            <div className="col-lg-8 d-flex align-items-center">
                                                {Recurring_Expense_details.add_status === "Expired" ?
                                                    <span className="badge badge-danger">Expired</span>
                                                    :
                                                    Recurring_Expense_details.add_status === "Cancelled" ?
                                                        <span className="badge badge-danger">Cancelled</span>
                                                        :
                                                        <span className="badge badge-primary">{Recurring_Expense_details.add_status}</span>

                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        navtype === "History" &&
                        <>
                            {/* <div className="card-header cursor-pointer py-0" style={{ minHeight: "45px" }}>
                                <div className="card-title m-0">
                                    History
                                </div>
                            </div> */}
                            {Recurring_Expense_details != undefined &&
                                <div className="card-body p-9">
                                    {additonalDetailsFlag !== true ?
                                        <>
                                            {Expense_history_details.length > 0 && Expense_history_details.map((obj, index) => {
                                                return (
                                                    <>
                                                        <div key={index} className="m-0">
                                                            <div className="d-flex align-items-sm-center mb-5">
                                                                <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                                                                    <div className="flex-grow-1 me-2">
                                                                        {obj.operation === "insert" ? <span className="badge badge-lg badge-secondary fw-bold my-2">Created</span> : obj.operation === "cancel" ? <span className="badge badge-lg badge-danger fw-bold my-2">Cancelled</span> : obj.operation === "expire" ? <span className="badge badge-lg badge-danger fw-bold my-2">Expired</span> : <span className="badge badge-lg badge-primary fw-bold my-2">Updated</span>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="timeline">
                                                                <div className="timeline-item align-items-center mb-7">
                                                                    <div className="timeline-line w-40px mt-6 mb-n12"></div>
                                                                    <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"></path>
                                                                        <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"></path>
                                                                        <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"></path>
                                                                    </svg>
                                                                    </span>
                                                                    <div className="timeline-content m-0">
                                                                        <span className="fs-6 text-gray-400 fw-semibold d-block">Date</span>
                                                                        <span className="fs-6 fw-bold text-gray-800">{moment(obj.log_date_time).format("lll")} </span>
                                                                    </div>
                                                                </div>
                                                                <div className="timeline-item align-items-center">
                                                                    <div className="timeline-line w-40px"></div>
                                                                    <span className="svg-icon svg-icon-1 svg-icon-primary me-3 lh-0"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
                                                                        <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
                                                                        <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
                                                                    </svg>
                                                                    </span>
                                                                    <div className="timeline-content m-0">
                                                                        <span className="fs-6 text-gray-400 fw-semibold d-block">User</span>
                                                                        <span className="fs-6 fw-bold text-gray-800">{obj.user_id}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {Expense_history_details.length > 1 &&
                                                            <div className="separator separator-dashed my-6"></div>
                                                        }
                                                    </>
                                                )
                                            })}
                                        </>
                                        :
                                        <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                    }
                                </div>
                            }
                        </>
                    }
                </div>
            </Drawer>
        </>
    );
};

export default RecurringExpenseList;
